import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Bar, HorizontalBar, Line } from 'react-chartjs-2';
import moment from 'moment';
import async from 'async';

import Config from '../../config';
import Lang from '../../languages';

import Statistics from './Statistics';


class Dashboard extends Component {
 constructor(props) {
  super(props);

  this.state = {
   totals: [],
   last: []
  };
 }

 componentDidMount() {
  var jobs = {};
  var self = this;

  jobs.totals = (function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/tickets/stats', 'POST', {
    groupBy: 'months',
    startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD')
   }).then(result => {
    callback(false, result);
   });
  })

  jobs.last = (function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/tickets/stats', 'POST', {
    groupBy: 'days',
    startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD')
   }).then(result => {
    callback(false, result);
   });
  })

  async.parallel(jobs, function (err, results) {
   self.setState(results);
  });
 }

 capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
 }


 render() {
  moment.locale(Lang[this.props.session.language].locale);

  let totalsLabels = [];
  let totalsDataset = { sales: [], bookings: [], cancellations: [] };

  this.state.totals.map(data => {
   totalsLabels.push(this.capitalizeFirstLetter(data.label));
   totalsDataset.sales.push(data.sales);
   totalsDataset.bookings.push(data.bookings);
   totalsDataset.cancellations.push(-data.cancellations);
  });

  let lastLabels = [];
  let lastDataset = { sales: [], bookings: [], cancellations: [] };

  this.state.last.map(data => {
   lastLabels.push(this.capitalizeFirstLetter(data.label));
   lastDataset.sales.push(data.sales);
   lastDataset.bookings.push(data.bookings);
   lastDataset.cancellations.push(data.cancellations);
  });


  return (
   <Row>

    <Col xs="4">
     <Card>
      <CardBody>
       <strong>{Lang[this.props.session.language].Dashboard.titles.totals}</strong>
       <HorizontalBar data={{
        labels: totalsLabels,
        datasets: [
         {
          label: Lang[this.props.session.language].Dashboard.labels.cancellations,
          data: totalsDataset.cancellations,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
         },
         {
          label: Lang[this.props.session.language].Dashboard.labels.bookings,
          data: totalsDataset.bookings,
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
         },
         {
          label: Lang[this.props.session.language].Dashboard.labels.sales,
          data: totalsDataset.sales,
          borderColor: 'rgb(57, 166, 57)',
          backgroundColor: 'rgba(57, 166, 57, 0.5)',
         }
        ],
       }} options={{
        scales: {
         xAxes: [{
          ticks: {
           stepSize: 1,
           beginAtZero: true
          }
         }]
        }
       }} legend={{ display: false }} height={100} />
      </CardBody>
     </Card>
    </Col>

    <Col xs="8">
     <Card>
      <CardBody>
       <strong>{Lang[this.props.session.language].Dashboard.titles.last}</strong>
       <Bar data={{
        labels: lastLabels,
        datasets: [
         {
          label: Lang[this.props.session.language].Dashboard.labels.cancellations,
          data: lastDataset.cancellations,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
         },
         {
          label: Lang[this.props.session.language].Dashboard.labels.bookings,
          data: lastDataset.bookings,
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
         },
         {
          label: Lang[this.props.session.language].Dashboard.labels.sales,
          data: lastDataset.sales,
          borderColor: 'rgb(57, 166, 57)',
          backgroundColor: 'rgba(57, 166, 57, 0.5)',
         }
        ],
       }} options={{
        scales: {
         yAxes: [{
          ticks: {
           stepSize: 1,
           beginAtZero: false
          }
         }]
        }
       }} legend={{ display: false }} height={47} />
      </CardBody>
     </Card>
    </Col>

    <Col xs="12">
     <Statistics {...this.props} />
    </Col>

   </Row>
  )
 }

}

export default Dashboard;




// WEBPACK FOOTER //
// ./websources/views/Dashboard/index.js